import { Sun, Moon } from '../../theme/icons.js';
import { useTheme } from '../../hooks/useTheme.js';

/**
 * Umschalter Hell/Dunkel — zwei Zustände, nicht drei.
 *
 * Das Icon zeigt, wohin der Klick führt, nicht den Ist-Zustand: im hellen
 * Design steht der Mond, im dunklen die Sonne. So macht es die Website
 * (vendor/dpsg/js/theme-switcher.js), und so liest sich ein Knopf auch
 * richtig — er sagt, was passiert, wenn man ihn drückt.
 *
 * `className` kommt von außen, damit der Knopf in die Umgebung passt
 * (z. B. "sidenav-icon-btn" oder "login-corner-btn").
 */
export function ThemeToggle({ className = '', size = 20 }) {
  const { theme, toggleTheme } = useTheme();
  const nachDunkel = theme !== 'dunkel';
  const label = nachDunkel ? 'Zum dunklen Design wechseln' : 'Zum hellen Design wechseln';

  return (
    <button
      type="button"
      className={className}
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {nachDunkel ? <Moon size={size} /> : <Sun size={size} />}
    </button>
  );
}

export default ThemeToggle;
